import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { removeFromLabels } from '@App/store/actions/search';

class SearchLabel extends Component {
    static propTypes = {
        reference: PropTypes.string.isRequired,
        remove: PropTypes.func.isRequired,
    };

    render() {
        const { reference, remove } = this.props;

        return (
            <div className="search-items--item search-label">
                {reference}
                <button className="search-items--remove" type="button" onClick={remove}>
                    <i className="icon icon--clear"></i>
                </button>
            </div>
        );
    }
}

export default connect(
    null,
    (dispatch, props) => ({
        remove: () => dispatch(removeFromLabels(props.reference)),
    })
)(SearchLabel);
